/** Card field → OrderInfo field. Card values are the same vocabulary as the form (benefit type included). */
export const INSURANCE_CARD_TO_ORDER_FIELD = {
    benefitType: "benefitType",
    memberId: "patientMemberId",
    memberName: "patientInsuranceMemberName",
    insuranceProvider: "insuranceProvider",
    insurancePlanType: "insurancePlanType",
    groupNumber: "grpNumber",
    rxBin: "bin",
    rxPcn: "processorControlNumber",
    state: "patientInsuranceState",
};
/** The non-empty (orderField, value) pairs a card contributes — blanks never overwrite what the form has. */
export function insuranceCardOrderFields(card) {
    return Object.entries(INSURANCE_CARD_TO_ORDER_FIELD).flatMap(([cardField, orderField]) => {
        const value = card[cardField];
        return value == null || value === "" ? [] : [[orderField, String(value)]];
    });
}
